import { push } from 'react-router-redux';
import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { clearDefaultForm } from 'actions';

import { submissionStages } from 'common/forms/submissionStages';

export const OPEN_FORM_SIGNING = 'OPEN_FORM_SIGNING';
export const CLOSE_FORM_SIGNING = 'CLOSE_FORM_SIGNING';
export const FORM_SIGNING_REQUEST = 'FORM_SIGNING_REQUEST';
export const FORM_SIGNING_SUCCESS = 'FORM_SIGNING_SUCCESS';
export const FORM_SIGNING_FAILURE = 'FORM_SIGNING_FAILURE';

function open() {
  return {
    type: OPEN_FORM_SIGNING
  };
}

function close() {
  return {
    type: CLOSE_FORM_SIGNING
  };
}

function request() {
  return {
    type: FORM_SIGNING_REQUEST
  };
}

function reject() {
  return {
    type: FORM_SIGNING_FAILURE
  };
}

function receive(workflowState) {
  return {
    type: FORM_SIGNING_SUCCESS,
    workflowState,
    submissionStage: submissionStages.Validating
  };
}

export function showFormSigning() {
  return (dispatch) => {
    dispatch(open());
  };
}

export function hideFormSigning() {
  return (dispatch) => {
    dispatch(close());
  };
}

export function signForm(formType, id, printName, capacity, signDate) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .sign(id, printName, capacity, signDate)
      .then((response) => {
        dispatch(receive(response.data.data));
        dispatch(clearDefaultForm());
        dispatch(push(`/forms/${ formType }/${ id }/success`));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          const code = error.response && error.response.data && error.response.data.error && error.response.data.error.code;
          if (code !== 499) {
            dispatch(handleException(error, close, true, false));
          } else {
            dispatch(handleException(error, reject, false, false));
          }
        }
      });

    return promise();
  };
}
